
import request from '@/utils/request'
const Rms_host = process.env.VUE_APP_PHP_RMS_API_HOST;

export function syncEquipDevApi(data) {
  return request({
    url: '?c=rms&a=equip-dev&do=sync',
    method: 'post',
    data
  })
}

export function loadEquipDevApi(equipid, devid) {
  return request({
    url: '?c=rms&a=equip-dev&do=load',
    method: 'post',
    data: {
      equipid,
      devid
    }
  })
}

export function loadDevApi(data) {
  return request({
    url: Rms_host + '?c=rms&a=dev&do=load',
    method: 'post',
    data
  })
}